import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Label } from "reactstrap";
import { H3 } from "../../../../../AbstractElements";
import { useEffect, useState } from "react";
import { useGetRequestQuery } from "../../../../../Hooks/useGetRequestQuery";
import { getCrmDDLService, getCrmLeadsFactFindService, updateFactFindService } from "../../../../../Services/CRMAdminServices/CRMTaskListService";
import AssetsProperty from "./FactFindAssetsProperty";
import TextField from "../../../../common/TextField";
import DropdownWithValueName from "../../../../common/DropdownWithValueName";
import FactFindClientDetails from "./FactFindClientDetails";
import { crmLeadFactFindData } from "../../FormData/CrmFormData";
import { useMutationRequestQuery } from "../../../../../Hooks/useMutationRequestQuery";
import { toast } from "react-toastify";
import SelectDatePicker from "../../../../common/SelectDatePicker";

export default function FactFind() {
    const location = useLocation();
    const [formErrors, setFormErrors] = useState<any>({});
    const navigate = useNavigate();
    const { leadID: leadId } = useParams();
    const isMMPAssetsLiabilitiesRoute = location.pathname === '/MMPAssetsLiabilities';

    const [formData, setFormData] = useState<any>(crmLeadFactFindData);

    const [leadDropdownData, setLeadDropdownData] = useState<any>([])

    const { data: leadsDataDDL, isLoading: DDLloading } = useGetRequestQuery<any>(
        ['getCrmDDLService'],
        () => getCrmDDLService(),
        { enabled: true }
    );

    useEffect(() => {
        if (leadsDataDDL?.data && !DDLloading) {
            setLeadDropdownData(leadsDataDDL?.data || []);
        }
    }, [leadsDataDDL]);

    const { data: leadsData, isLoading, isError } = useGetRequestQuery<any>(
        ['getCrmLeadsFactFindService', leadId],
        () => getCrmLeadsFactFindService(leadId),
        { enabled: !!leadId }
    );

    useEffect(() => {
        if (leadsData && !isError && !isLoading) {
            setFormData(leadsData?.data || []);
        }
    }, [leadsData, isError, isLoading, leadId]);

    const handleValueChange = (name: string, value: string | Date | null) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: "",
        }));
    };

    const handlePrint = () => {
        window.print();
    };
    const {
        mutate: updateLeadFactFind,
        isPending: isLeadBulkPending,
    } = useMutationRequestQuery("updateFactFindService", updateFactFindService, {
        onSuccess: () => {
            toast.success("Fact Find saved successfully.");
        },
        onError: () => {
            toast.error("Failed to update leads.");
        },
    });

    const handleSubmit = () => {
        const { guidid, factfindId, leadID, ...filteredData } = formData;
        const payload = { ...filteredData, clientid: leadId };
        updateLeadFactFind(payload);
    };

    return (
        <>
            <div className={isMMPAssetsLiabilitiesRoute ? 'mmp-assets-liabilities container-fluid' : 'container-fluid'}>
                <div className="table-responsive h-100 py-4" id="print-area">
                    <section className='bg-white'>

                        <div className="scrollable-table-container">
                            <table className="scrollable-table" style={{ marginLeft: '1%', marginTop: '3%' }}>
                                <div className="d-flex align-items-center">
                                    <Col xs={12} className='d-flex'>
                                        <H3 className="heading-color f-w-900 text-left my-2">
                                            Fintrack Fact Find &nbsp; &nbsp;&nbsp;&nbsp; {` ${(leadsData?.data?.firstName || "") + " " + (leadsData?.data?.surname || "")}`}
                                        </H3>
                                    </Col>
                                </div>
                                <div className='d-flex flex-wrap item-center mt-2'>
                                    <Col className="responsive-col mb-3" xs={12} style={{ width: '8%', paddingInline: '2px' }}>
                                        <Label className="mt-2"> Client Name :</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                        <TextField
                                            label=""
                                            type="text"
                                            name="firstName"
                                            value={(leadsData?.data?.firstName || "") + (leadsData?.data?.surname || "") || ""}
                                            setValue={handleValueChange}
                                            design="flex"
                                            disabled
                                            passCol='col-10'
                                            maxChars={20}
                                        />
                                    </Col>
                                    <Col className="responsive-col mb-3" xs={12} style={{ width: '4%', paddingInline: '2px' }}>
                                        <Label className="mt-2">Date :</Label>
                                    </Col>
                                    <Col className="responsive-col" xs={12} style={{ width: '13%', paddingInline: '2px' }}>
                                        <SelectDatePicker
                                            label=""
                                            name="followUp"
                                            value={formData.followUp}
                                            setValue={handleValueChange}
                                            design="flex"
                                            passCol='col-10'
                                        />
                                    </Col>
                                    <Col className="responsive-col mb-3" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                        <Label className="mt-2">Source:</Label>
                                    </Col>
                                    <DropdownWithValueName
                                        label=""
                                        name="source"
                                        value={formData.source}
                                        disabled
                                        setValue={handleValueChange}
                                        options={leadDropdownData?.leadSources || []}
                                        passCol="col-10"
                                        design="flex"
                                    />
                                    <Col className="responsive-col mb-3" xs={12} style={{ width: '5%', paddingInline: '2px' }}>
                                        <Label className="mt-2">Staff:</Label>
                                    </Col>
                                    <DropdownWithValueName
                                        label=""
                                        name="staff"
                                        value={formData.staff}
                                        setValue={handleValueChange}
                                        options={leadDropdownData?.staff || []}
                                        passCol="col-10"
                                        design="flex"
                                    />
                                    <Col className="responsive-col mb-3" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                        <Button color="primary" style={{ width: "100%" }} onClick={handleSubmit} disabled={isLeadBulkPending}>
                                            {isLeadBulkPending ? "Loading" : "Save"}
                                        </Button>
                                    </Col>
                                    <Col className="responsive-col mb-3" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                        <Button color="success" style={{ width: "100%" }} onClick={handlePrint}>
                                            PDF
                                        </Button>
                                    </Col>
                                    <Col className="responsive-col mb-3" xs={12} style={{ width: '7%', paddingInline: '2px' }}>
                                        <Button color="warning" onClick={() => navigate(-1)} style={{ width: "100%" }}>
                                            Back
                                        </Button>
                                    </Col>
                                </div>
                                <FactFindClientDetails formData={formData} setFormData={setFormData} />
                            </table>
                        </div>
                    </section>
                </div>
            </div>
            <AssetsProperty clientId={leadId} />
        </>
    )
}
